import React from 'react'

const Notfound = () => {
  return (
    <div className='notfound'>Page Not Found 404</div>
  )
}

export default Notfound